import { Instance } from 'mobx-state-tree';
import { TeamMemberPaginatedDtoModelBase } from './TeamMemberPaginatedDtoModel.base';

/* The TypeScript type of an instance of TeamMemberPaginatedDtoModel */
export interface TeamMemberPaginatedDtoModelType extends Instance<typeof TeamMemberPaginatedDtoModel.Type> {}

/* A graphql query fragment builders for TeamMemberPaginatedDtoModel */
export { selectFromTeamMemberPaginatedDto, teamMemberPaginatedDtoModelPrimitives, TeamMemberPaginatedDtoModelSelector } from './TeamMemberPaginatedDtoModel.base';

/**
 * TeamMemberPaginatedDtoModel
 */
export const TeamMemberPaginatedDtoModel = TeamMemberPaginatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
